import Axios from 'axios'

import {
  CreatedMcpOAuthClient,
  McpOAuthClient
} from 'types/GlobalMcpOAuthClient'

import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/mcp-oauth-clients`

// One credential pair per customer — GET returns it (or null).
export async function getOne() {
  return Axios.get<{ data: McpOAuthClient | null }>(
    URL,
    parseAuthenticationHeader()
  )
}

// Creates the pair, or rotates it if one exists (old credentials stop
// working immediately). The secret in the response is shown exactly once.
export async function createOrReplace() {
  return Axios.post<{ data: CreatedMcpOAuthClient }>(
    URL,
    {},
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
